import React, { FC, ReactNode } from 'react'
import styles from './InfoTitleValue.module.scss'
import classNames from 'classnames'

type InfoTitleValueProps = {
  title: string | ReactNode
  value: string | ReactNode
  isTwoColumns?: boolean
}

const InfoTitleValue: FC<InfoTitleValueProps> = ({ title, value, isTwoColumns }) => {
  return (
    <div
      className={classNames(styles.titleValueContainer, {
        [styles.twoColumns]: isTwoColumns,
      })}
    >
      <div className={styles.titleValueTitle}>
        <h5>{title}</h5>
      </div>
      <div className={styles.titleValueValue}>
        <p>{value}</p>
      </div>
    </div>
  )
}

export default InfoTitleValue
